import makeStyles from '@material-ui/styles/makeStyles';

export default makeStyles({
  input: {
    fontSize: '2rem'
  }
});
